import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gift } from "lucide-react";
import { DateField } from "@/components/DateField";
import { Input } from "@/components/ui-kit";
import { api, errorText } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";
import { fmtDateTime } from "@/lib/time";

interface Ex { end: string; end_date?: string; reason: string; history?: { end_date: string; reason: string; by: string; at: string }[] }

export const LaunchExemption = ({ canEdit }: { canEdit: boolean }) => {
  const { t, lang } = usePrefs();
  const [ex, setEx] = useState<Ex | null>(null);
  const [date, setDate] = useState("");
  const [reason, setReason] = useState("");
  useEffect(() => {
    api.get("/admin/launch-exemption").then((r) => {
      setEx(r.data);
      setDate(r.data.end_date || new Date(new Date(r.data.end).getTime() - 1).toLocaleDateString("en-CA", { timeZone: "Asia/Baghdad" }));
    }).catch(() => {});
  }, []);
  const save = async () => {
    try {
      const { data } = await api.put("/admin/launch-exemption", { end_date: date, reason });
      setEx(data);
      setReason("");
      toast.success(t("b7.launchSaved"));
    } catch (e) {
      toast.error(errorText(e, t));
    }
  };
  if (!ex) return null;
  return (
    <div data-testid="launch-exemption-card" className="rounded-3xl border bg-card p-5 space-y-3">
      <p className="font-bold flex items-center gap-2"><Gift className="h-5 w-5 text-primary" />{t("b7.launchTitle")}</p>
      <p className="text-sm text-muted-foreground">{t("b7.launchNote")}</p>
      <div className="flex flex-wrap items-end gap-2">
        <label className="text-xs font-bold space-y-1">{t("b7.endDate")}
          <DateField value={date} disabled={!canEdit} onChange={setDate} testId="launch-exemption-date" />
        </label>
        {canEdit && <Input value={reason} onChange={(e: any) => setReason(e.target.value)} placeholder={t("b7.reason")} data-testid="launch-exemption-reason" className="h-10 rounded-full flex-1 min-w-[180px]" />}
        {canEdit && <button onClick={save} disabled={!date || reason.trim().length < 3} data-testid="launch-exemption-save" className="h-10 px-5 rounded-full bg-primary text-primary-foreground text-sm font-bold disabled:opacity-50">{t("common.save")}</button>}
      </div>
      {!!ex.history?.length && (
        <div className="text-xs text-muted-foreground space-y-0.5">
          <p className="font-bold">{t("b7.history")}</p>
          {ex.history.slice(-5).reverse().map((h, i) => <p key={i}>{h.end_date} — {h.reason} · {h.by} · {fmtDateTime(h.at, lang)}</p>)}
        </div>
      )}
    </div>
  );
};
